import { Button } from 'antd'
import styled from 'styled-components'

const StyledButton = styled(Button)`
  width: 156px;
  height: 47px;
  font-size: 17px;
  font-weight: 500;
`

interface Props {
  handlePress: () => void
  loading?: boolean
  disabled?: boolean
}

export const ExportButton: React.FC<Props> = ({ handlePress, loading, disabled }) => {
  return (
    <StyledButton disabled={disabled} loading={loading} onClick={handlePress}>
      Exportar
    </StyledButton>
  )
}
